<div class="page-wrapper">
  <app-web-navbar></app-web-navbar>

  <section class="products-section" style="padding-top: 40px; min-height: 60vh;">
    <div class="container-fluid px-lg-5">
      <div class="eshopper-section-title">
        <span class="line"></span>
        <h3>{{ product?.productName }} - Variants</h3>
        <span class="line"></span>
      </div>

      <div class="row g-4">
        <!-- No Variants Message -->
        <div *ngIf="!variants || variants.length === 0" class="col-12 text-center py-5">
          <img src="assets/img/icons/empty-product.avif" alt="No Variants"
            class="empty-product-image mb-3 opacity-75" />
          <h5 class="fw-semibold text-muted mb-1">No Variants Found</h5>
          <p class="text-secondary small">
            There are no variants available for this product at the moment.
          </p>
        </div>

        <!-- Variant Cards -->
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let variant of variants">
          <div class="product-card" (click)="navigateToDetailView(variant.productVariantId)">
            <div class="product-img-box position-relative">
              <img [src]="getImageUrl(variant)" [alt]="product?.productName" loading="lazy"
                (error)="onImageError($event)" />
            </div>
            <div class="product-info" style="text-align: center; padding-top: 10px;">
              <h6 class="product-name" style="margin-bottom: 5px;">{{ variant.size ? variant.size : product?.productName
                }}</h6>
              <div class="product-price" style="margin-bottom: 10px; font-weight: bold; color: #1a1a2e;">
                ₹{{ variant.productSrp }}
                <span *ngIf="variant.productMrp > variant.productSrp"
                  style="text-decoration: line-through; color: #999; font-size: 12px; margin-left: 5px;">
                  ₹{{ variant.productMrp }}
                </span>
              </div>
              <div class="product-actions">
                <button type="button" class="btn btn-sm add-cart-btn" [disabled]="isSubmitting"
                  (click)="addToCart(variant, $event)">
                  <i class="bi bi-bag-plus me-1"></i>
                  {{ isSubmitting ? 'Please wait...' : 'Add to Cart' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-web-footer></app-web-footer>

  <!-- ===== LOGIN MODAL ===== -->
  <div class="auth-backdrop" *ngIf="isLoginModalOpen">
    <div class="auth-modal-wrapper" (click)="$event.stopPropagation()">
      <div class="auth-modal login-theme">

        <button type="button" class="auth-close" aria-label="Close login" (click)="closeLoginModal()">
          &times;
        </button>

        <div class="auth-icon">
          <i class="fa-solid fa-user-lock"></i>
        </div>

        <h2 class="auth-title">Welcome Back!</h2>

        <p class="auth-subtitle">
          Sign in to continue shopping and manage your orders.
        </p>

        <!-- EMAIL STEP -->
        <div class="auth-body" *ngIf="loginStep === 'email'">
          <div>
            <label class="auth-label" for="loginEmail">
              Email Address
            </label>

            <input id="loginEmail" type="email" class="auth-input" name="loginEmail" [(ngModel)]="loginEmail"
              placeholder="Enter your email address" autocomplete="email" />

            <small class="auth-hint">
              We'll send a one-time password to verify your email.
            </small>
          </div>

          <p class="auth-error" *ngIf="loginError">
            {{ loginError }}
          </p>

          <button type="button" class="auth-submit" [disabled]="isSubmitting" (click)="loginSendOtpApi()">
            {{ isSubmitting ? 'Sending OTP...' : 'Send OTP' }}
          </button>
        </div>

        <!-- OTP STEP -->
        <div class="auth-body" *ngIf="loginStep === 'otp'">
          <div>
            <label class="auth-label" for="loginOtp">
              Enter Verification Code
            </label>

            <input id="loginOtp" type="text" class="auth-input auth-otp-input" name="loginOtp" [(ngModel)]="loginOtp"
              placeholder="Enter 4-digit OTP" inputmode="numeric" autocomplete="one-time-code" maxlength="4"
              (input)="onLoginOtpInput($event)" />

            <small class="auth-hint">
              Enter the OTP sent to {{ loginEmail }}.
            </small>
          </div>

          <p class="auth-error" *ngIf="loginError">
            {{ loginError }}
          </p>

          <button type="button" class="auth-submit" [disabled]="isSubmitting" (click)="loginVerifyOtpApi()">
            {{ isSubmitting ? 'Verifying...' : 'Verify & Login' }}
          </button>

          <button type="button" class="auth-text-button auth-center-button" (click)="loginStep = 'email'">
            Change email address
          </button>
        </div>

        <div class="auth-footer">
          New to our store?
          <button type="button" class="auth-text-button" (click)="switchToRegister()">
            Create an account
          </button>
        </div>

        <!-- <p class="auth-privacy">
        Your information is used to help secure your account.
      </p> -->

      </div>
    </div>
  </div>


  <!-- REGISTRATION MODAL -->
  <div class="auth-backdrop" *ngIf="isRegisterModalOpen">
    <div class="auth-modal-wrapper" (click)="$event.stopPropagation()">
      <div class="auth-modal register-theme">

        <button type="button" class="auth-close" aria-label="Close registration" (click)="closeRegisterModal()">
          &times;
        </button>

        <div class="auth-icon">
          <i class="bi bi-person-plus"></i>
        </div>

        <h2 class="auth-title">Create Your Account</h2>

        <p class="auth-subtitle">
          Join us for a simple and convenient shopping experience.
        </p>

        <!-- REGISTRATION EMAIL STEP -->
        <div class="auth-body" *ngIf="registerStep === 'email'">
          <div>
            <label class="auth-label" for="registerEmail">
              Email Address
            </label>

            <input id="registerEmail" type="email" class="auth-input" name="registerEmail" [(ngModel)]="registerEmail"
              placeholder="Enter your email address" autocomplete="email" />

            <small class="auth-hint">
              We'll send an OTP to verify your email address.
            </small>
          </div>

          <p class="auth-error" *ngIf="registerError">
            {{ registerError }}
          </p>

          <button type="button" class="auth-submit" [disabled]="isSubmitting" (click)="registrationSendOtpApi()">
            {{ isSubmitting ? 'Sending OTP...' : 'Send OTP' }}
          </button>
        </div>

        <!-- REGISTRATION OTP STEP -->
        <div class="auth-body" *ngIf="registerStep === 'otp'">
          <div>
            <label class="auth-label" for="registerOtp">
              Enter Verification Code
            </label>

            <input id="registerOtp" type="text" class="auth-input auth-otp-input" name="registerOtp"
              [(ngModel)]="registerOtp" placeholder="Enter 4-digit OTP" inputmode="numeric" autocomplete="one-time-code"
              maxlength="4" (input)="onRegisterOtpInput($event)" />

            <small class="auth-hint">
              Enter the OTP sent to {{ registerEmail }}.
            </small>
          </div>

          <p class="auth-error" *ngIf="registerError">
            {{ registerError }}
          </p>

          <button type="button" class="auth-submit" [disabled]="isSubmitting" (click)="registrationVerifyOtpApi()">
            {{ isSubmitting ? 'Verifying...' : 'Verify Email' }}
          </button>

          <button type="button" class="auth-text-button auth-center-button" (click)="registerStep = 'email'">
            Change email address
          </button>
        </div>

        <!-- REGISTRATION DETAILS STEP -->
        <div class="auth-body" *ngIf="registerStep === 'details'">
          <div>
            <label class="auth-label" for="registerFirstName">
              Full Name
            </label>

            <input id="registerFirstName" type="text" class="auth-input" name="firstName" [(ngModel)]="firstName"
              placeholder="Enter your full name" autocomplete="name" />
          </div>

          <div>
            <label class="auth-label" for="registerPhone">
              Mobile Number
            </label>

            <input id="registerPhone" type="tel" class="auth-input" name="phoneNumber" [(ngModel)]="phoneNumber"
              placeholder="Enter your 10-digit mobile number" inputmode="numeric" autocomplete="tel" maxlength="10" />
          </div>

          <p class="auth-error" *ngIf="registerError">
            {{ registerError }}
          </p>

          <button type="button" class="auth-submit" [disabled]="isSubmitting" (click)="completeRegistration()">
            {{ isSubmitting ? 'Creating Account...' : 'Create Account' }}
          </button>
        </div>

        <div class="auth-footer">
          Already have an account?
          <button type="button" class="auth-text-button" (click)="switchToLogin()">
            Login
          </button>
        </div>

        <!-- <p class="auth-privacy">
        Your account details help us provide a better shopping experience.
      </p> -->

      </div>
    </div>
  </div>


</div>